<template>
  <app-layout>
    <app-layout-header>
      <app-header title="重置密码" primary>
        <router-link slot="right" :to="{ name: 'Login' }">登录</router-link>
      </app-header>
    </app-layout-header>
    <app-layout-body>
      <div class="page page-forgot-password">
        <div class="page-forgot-password__header">
          <el-steps :active="active" align-center>
            <el-step title="账号验证"></el-step>
            <el-step title="验证手机号"></el-step>
            <el-step title="设置新密码"></el-step>
            <el-step title="完成"></el-step>
          </el-steps>
        </div>
        <div class="page-forgot-password__body">
          <div class="page-forgot-password__step" v-if="active === 0" key="0">
            <el-form class="demo-ruleForm" :model="formOne" :rules="rulesOne" ref="formOne" label-width="100px">
              <el-form-item label="账号" prop="username" size="small">
                <el-input type="text" v-model="formOne.username" placeholder="请输入账号"></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="captcha" size="small">
                <div class="page-forgot-password__captcha">
                  <el-input type="text" v-model="formOne.captcha" placeholder="请输入验证码" auto-complete="off"></el-input>
                  <img :src="imageCaptcha" alt="captcha">
                  <span>看不清？<a @click.prevent="getImageCaptcha">换一个</a></span>
                </div>
              </el-form-item>
              <el-form-item class="page-forgot-password__next">
                <el-button type="primary" size="small" @click="next('formOne')">下一步</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="page-forgot-password__step" v-if="active === 1" key="1">
            <el-form class="demo-ruleForm" :model="formTwo" :rules="rulesTwo" ref="formTwo" label-width="100px">
              <el-form-item size="small">
                <div class="page-forgot-password__step__label">请输入您绑定的手机号码</div>
                <span class="page-forgot-password__step__value">{{ cellphone }}</span>
              </el-form-item>
              <el-form-item label="手机号" prop="cellphone" size="small">
                <el-input type="text" v-model="formTwo.cellphone" placeholder="请输入手机号码"></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="phoneCaptcha" size="small">
                <div class="page-forgot-password__captcha">
                  <el-input type="text" v-model="formTwo.phoneCaptcha" placeholder="请输入短信验证码" auto-complete="off"></el-input>
                  <el-button type="info" @click.prevent="sendPhoneCaptcha('formTwo')" :disabled="countdown > 0" plain>{{ countdown > 0 ? `${countdown}s后重新发送` : '发送验证码' }}</el-button>
                </div>
              </el-form-item>
              <el-form-item class="page-forgot-password__next">
                <el-button type="primary" size="small" @click="next('formTwo')">下一步</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="page-forgot-password__step" v-if="active === 2" key="2">
            <el-form class="demo-ruleForm" :model="formThree" :rules="rulesThree" ref="formThree" label-width="100px">
              <el-form-item label="新密码" prop="newPassword" size="small">
                <el-input type="password" v-model="formThree.newPassword" placeholder="请输入新密码"></el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="confirmPassword" size="small">
                <el-input type="password" v-model="formThree.confirmPassword" placeholder="请再次输入密码"></el-input>
              </el-form-item>
              <el-form-item class="page-forgot-password__next">
                <el-button type="primary" size="small" @click="next('formThree')">下一步</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="page-forgot-password__step" v-if="active === 3" key="3">
            <div class="page-forgot-password__message">
              <div class="page-forgot-password__message__icon">
                <app-svg-icon icon-class="success" style="width: 36px; height: 36px;"></app-svg-icon>
              </div>
              <p class="page-forgot-password__message__text">修改完成，请重新登录</p>
            </div>
            <div class="page-forgot-password__message__finish">
              <el-button type="primary" size="small" @click="jumpToLogin">重新登录</el-button>
            </div>
          </div>
        </div>
      </div>
    </app-layout-body>
    <app-layout-footer></app-layout-footer>
  </app-layout>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import { validateCellphone, validatePassword } from '@/utils'

export default {
  name: 'ForgotPassword',
  components: {
    AppHeader
  },

  data () {
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else if (!validateCellphone(value)) {
        callback(new Error('请输入11位正确的手机号'))
      } else {
        callback()
      }
    }

    const validateNewPassword = (rule, value, callback) => {
      const { confirmPassword } = this.formThree

      if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (!validatePassword(value)) {
        callback(new Error('密码格式为 6-16 位数字及字母组成，不能含有特殊字符'))
      } else if (confirmPassword && value !== confirmPassword) {
        callback(new Error('两次输入密码不一致，请重新输入'))
      } else {
        callback()
      }
    }

    const validateConfirmPassword = (rule, value, callback) => {
      const { newPassword } = this.formThree

      if (value === '') {
        callback(new Error('请输入确认密码'))
      } else if (!validatePassword(value)) {
        callback(new Error('密码格式为 6-16 位数字及字母组成，不能含有特殊字符'))
      } else if (newPassword && value !== newPassword) {
        callback(new Error('两次输入密码不一致，请重新输入'))
      } else {
        callback()
      }
    }

    return {
      active: 0,
      imageCaptcha: '',
      captchaId: '',
      cellphone: '',
      randomCode: '',
      formOne: {
        username: '',
        captcha: ''
      },
      rulesOne: {
        username: { required: true, message: '请输入账号名称', trigger: 'change' },
        captcha: { required: true, message: '请输入验证码', trigger: 'change' }
      },
      formTwo: {
        cellphone: '',
        phoneCaptcha: ''
      },
      rulesTwo: {
        cellphone: { required: true, validator: validatePhone, trigger: 'change' },
        phoneCaptcha: { required: true, message: '请输入短信验证码', trigger: 'change' }
      },
      formThree: {
        newPassword: '',
        confirmPassword: ''
      },
      rulesThree: {
        newPassword: { required: true, validator: validateNewPassword, trigger: 'change' },
        confirmPassword: { required: true, validator: validateConfirmPassword, trigger: 'change' }
      }
    }
  },

  computed: {
    countdown () {
      return this.$store.state.account.countdown
    }
  },

  created () {
    this.getImageCaptcha()
  },

  methods: {
    next (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this[`${formName}Submit`](() => {
            if (this.active++ > 3) this.active = 0
          })
        }
      })
    },

    getImageCaptcha () {
      this.$store.dispatch('getImageCaptcha').then(response => {
        const { data, headers } = response
        this.captchaId = headers.captchaid
        this.imageCaptcha = URL.createObjectURL(data)
      }).catch(() => {
        // No handler
      })
    },

    formOneSubmit (cb) {
      this.$store.dispatch('verifyAccount', {
        body: {
          username: this.formOne.username,
          imageCodeId: this.captchaId,
          imageCode: this.formOne.captcha
        }
      }).then(response => {
        const { phoneNumber, randomCode } = response.data
        this.cellphone = phoneNumber
        this.randomCode = randomCode
        cb && cb()
      }).catch(() => {
        // No handler
      })
    },

    getPhoneCaptcha () {
      this.$store.dispatch('getPhoneCaptcha', {
        body: {
          phoneNumber: this.formTwo.cellphone,
          messageType: 2, // 短信验证码类型 1：登录 2：忘记密码 3：修改绑定手机
          randomCode: this.randomCode
        }
      })
    },

    formTwoSubmit (cb) {
      this.$store.dispatch('verifyMessage', {
        body: {
          phoneNumber: this.formTwo.cellphone,
          messageCode: this.formTwo.phoneCaptcha
        }
      }).then(response => {
        const { randomCode } = response.data
        this.randomCode = randomCode
        cb && cb()
      }).catch(() => {
        // No handler
      })
    },

    formThreeSubmit (cb) {
      this.$store.dispatch('resetPassword', {
        body: {
          newPassword: this.formThree.newPassword,
          newPasswordConfirm: this.formThree.confirmPassword,
          randomCode: this.randomCode
        }
      }).then(response => {
        const { randomCode } = response.data
        this.randomCode = randomCode
        cb && cb()
      }).catch(() => {
        // No handler
      })
    },

    jumpToLogin () {
      this.$router.push({ name: 'Login' })
    },

    checkPhone (formName, cb) {
      this.$refs[formName].validateField('cellphone', (errorMessage) => {
        if (!errorMessage) cb && cb()
      })
    },

    sendPhoneCaptcha (formName) {
      this.checkPhone(formName, () => {
        this.getPhoneCaptcha()
      })
    }
  }
}
</script>

<style lang="scss">
.page-forgot-password {
  &__header {
    padding: 50px 0 30px;
  }

  &__body {
    min-height: 350px;
    padding: 100px 15px;
    background-color: #fff;
  }

  &__step {
    width: 450px;
    margin: 0 auto;

    &__label {
      color: #999;
      font-size: 16px;
    }

    &__value {
      font-family: sans-serif;
      font-weight: 700;
    }
  }

  &__captcha {
    display: flex;

    .el-input {
      flex: 1;
    }

    .el-button {
      width: 30%;
      margin-left: 10px;
    }

    img {
      height: 32px;
      margin-left: 10px;
      background-color: black;
    }

    > span {
      margin-left: 10px;
      font-size: 12px;

      a {
        color: $primary-color;
      }
    }
  }

  &__next {
    margin-bottom: 0;
  }

  &__message {
    text-align: center;

    &__icon {
      color: #67c23a;
    }

    &__finish {
      margin-top: 30px;
      text-align: center;
    }
  }
}
</style>
